import { UserBlockArgs } from 'types/api/arguments/user-block-args'

import { api } from './api'

export const unblockUser = ({ currentUserId, blockedUserId }: UserBlockArgs) =>
  api.delete(`/users/${currentUserId}/user_hates`, { params: { hated_user_id: blockedUserId } })
